import { gettext } from '@eventbrite/i18n';

export const HISTORY_SUGGESTIONS_SHOWN = 5;
export const BROWSING_ONLINE_EVENTS_TEXT = gettext('Online');
export const ONLINE_EVENTS_LOCATION_SLUG = 'online';
export const SUGGESTION_TYPE_HISTORY = 'recent';
